import type {
  CustomEventMap,
  EventCallback,
  EventToken,
  SubscribeEvent,
  TriggerEvent,
  UnsubscribeEvent,
} from '@shared/event/types'

import { isBrowser, isSSR } from '@fond-of/env'

export const triggerEvent: TriggerEvent = <K extends keyof CustomEventMap>(
  name: K,
  eventDetail: CustomEventMap[K]
) => {
  if (isSSR()) {
    return
  }

  window.dispatchEvent(
    new CustomEvent<CustomEventMap[K]>(name, {
      detail: eventDetail,
    })
  )
}

export const subscribeEvent: SubscribeEvent = <K extends keyof CustomEventMap>(
  name: K,
  callback: EventCallback<CustomEventMap[K]>
) => {
  const token = (customEvent: CustomEvent<CustomEventMap[K]>) =>
    callback(customEvent.detail, customEvent)

  if (isBrowser()) {
    window.addEventListener<typeof name>(name, token)
  }

  return token
}

export const unsubscribeEvent: UnsubscribeEvent = <
  K extends keyof CustomEventMap,
>(
  name: K,
  token: EventToken<CustomEventMap[K]>
) => {
  if (isSSR()) {
    return
  }

  window?.removeEventListener<typeof name>(name, token)
}
